export class GridusException extends Error {
  public status: string;
  public code: string;
  public title: string;

  constructor(
    message: string,
    code: string = 'L0001',
    status: string = 'error'
  ) {
    super(message);
    this.name = this.constructor.name;
    this.status = status;
    this.code = code;
    this.title = this.name;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GridusException);
    }
  }

  toJSON() {
    return {
      status: this.status,
      code: this.code,
      title: this.title,
      message: this.message || 'Internal Server Error',
    };
  }
}
